import React, { useRef, useEffect } from 'react'
import { Title } from 'react-admin'
import { Box } from '@material-ui/core'

export default () => {
  const ref = useRef(null)
  const url =
    'https://10ay.online.tableau.com/t/orchestraaetc/views/Analyticstest/Dashboard1?:showAppBanner=false&:display_count=n&:showVizHome=n&:origin=viz_share_link'

  useEffect(() => {
    import('tableau-api').then(() => {
      new window.tableau.Viz(ref.current, url)
    })
  }, [])

  return (
    <Box display="flex" flexDirection="column" alignItems="center" pt={2}>
      <Title title="Analytics" />

      <div ref={ref} />
    </Box>
  )
}
